import {
  attachAsyncAppsFromManifest,
  initFederation,
  loadManifest,
} from "@gohighlevel/ghl-module-federation-plugin";

let remoteConfigEnv = {
  development: {
    formSurveyApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/form-survey--ver--smit-pdf/remoteEntry.js?nocache=true",
  },
  staging: {
    formSurveyApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/form-survey--ver--smit-pdf/remoteEntry.js?nocache=true",
  },
  interop: {
    formSurveyApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/form-survey/remoteEntry.js?nocache=true",
  },
  beta: {
    formSurveyApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/form-survey/remoteEntry.js?nocache=true",
  },
  production: {
    formSurveyApp:
      "https://appcdn.leadconnectorhq.com/leadgen/form-survey/remoteEntry.js?nocache=true",
  },
};

export const initRemoteApps = async () => {
  const env = process.env.NODE_ENV;

  const buildRemotes = (config) =>
    Object.entries(config).map(([key, entry]) => ({
      name: key,
      alias: key,
      entry,
    }));

  const initWithRemotes = (config) => {
    const remoteApps = buildRemotes(config);
    initFederation({
      name: "form-survey-builder-runtime-remote-apps",
      remotes: remoteApps,
    });
  };

  if (env !== "development" && env !== "staging") {
    await loadManifest(env);
    remoteConfigEnv = attachAsyncAppsFromManifest(remoteConfigEnv[env], env);
    initWithRemotes(remoteConfigEnv);
    return;
  }
  initWithRemotes(remoteConfigEnv[env]);
};
